<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600">
    <v-row>
      <v-col>
        <v-text-field
          v-model="name"
          label="Name"
          required
          hide-details
          :outlined="outlinedInputs"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="description"
          label="Description"
          required
          hide-details
          :outlined="outlinedInputs"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-select
          v-model="type"
          :items="attrTypes"
          label="Type"
          required
          hide-details
          :outlined="outlinedInputs"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="order"
          label="Order"
          type="number"
          hide-details
          :outlined="outlinedInputs"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-checkbox v-model="isRequired" label="Is Required" hide-details />
      </v-col>
    </v-row>

    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <template v-slot:title>{{ editorTitle }}</template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
export default {
  components: { BasicDialog },
  name: "c-data-type-attribute-edit-dialog",

  props: {
    show: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      debug: false,
      id: this.value ? this.value.id : "",
      name: this.value ? this.value.name : "",
      description: this.value ? this.value.description : "",
      attrTypes: ["STRING", "BOOLEAN", "DATE", "TIME"],
      type: this.value ? this.value.type : "STRING",
      isRequired: this.value ? this.value.isRequired : false,
      order: this.value ? this.value.order : 0,
    };
  },

  computed: {
    editorTitle() {
      return this.value
        ? "Edit Custom Data Type Attribute"
        : "Add Custom Data Type Attribute";
    },
    isValid() {
      return this.name != "" && this.type != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.id = newVal ? newVal.id : "";
      this.name = newVal ? newVal.name : "";
      this.description = newVal ? newVal.description : "";
      this.type = newVal ? newVal.type : "STRING";
      this.isRequired = newVal ? newVal.isRequired : false;
      this.order = newVal ? newVal.order : 0;
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.id != "" ? this.id : undefined,
        name: this.name,
        description: this.description,
        type: this.type,
        isRequired: this.isRequired,
        order: parseInt(this.order),
      });
      this.$emit("close");
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/admin/cd-types/CDataTypeAttributeEditDialog.vue